const OK = 200;
const MULTIPLE_CHOICES = 300;
const UNAUTHORIZED = 401;
const REQUEST_TIMEOUT = 408;
const TOO_MANY_REQUESTS = 429;
const SERVER_ERROR_RETRY_RANGE_START = 500;
const SERVER_ERROR_RETRY_RANGE_END = 504;

export const HttpStatus = {
  OK,
  MULTIPLE_CHOICES,
  UNAUTHORIZED,
  REQUEST_TIMEOUT,
  TOO_MANY_REQUESTS,
  SERVER_ERROR_RETRY_RANGE_START,
  SERVER_ERROR_RETRY_RANGE_END,
};
